import { Injectable, inject } from '@angular/core';

import { AppConfig } from '@models/app.model';

import { StoreService } from '@cxc/core/services';

@Injectable({ providedIn: 'root' })
export class AppConfigStore {
  private storeService = inject(StoreService);
  private storageKey = 'App-Config';

  constructor() {
    this.storeService.add(this.storageKey, {
      allowRoutes: {
        '2FA': false,
        'change-password': false,
      },
    } as AppConfig);
  }

  get() {
    return this.storeService.get<AppConfig>(this.storageKey);
  }

  set(value: AppConfig) {
    this.storeService.set(this.storageKey, value);
  }

  patch(value: Partial<AppConfig>) {
    this.storeService.patch(this.storageKey, value);
  }
}
